import Swiper from 'swiper';

export default function threeColumnSliderInit() {
  if (window.innerWidth < 992) {
    // eslint-disable-next-line
    let threeColumnSlider = new Swiper ('.three-column-slider', {
      width: 280,
      spaceBetween: 60,
      freeMode: true,
      scrollbar: {
        el: '.three-column-slider__scrollbar',
        hide: false,
        draggable: true,
      },
      breakpoints: {
        576: {
          width: 341,
          spaceBetween: 141,
        },
      },
    });
  } else {
    // eslint-disable-next-line
    let threeColumnSlider = new Swiper ('.three-column-slider', {
      slidesPerView: 3,
      spaceBetween: 35,
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/partials/three-column-slider.js